// extracted by mini-css-extract-plugin
module.exports = {"filtersSelector":"sFilterSelector_filtersSelector__CtsbY"};